import React, { ChangeEvent, FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Tabs, Unstable_Grid2 as Grid } from '@mui/material';

import { UserStatus } from 'api';
import { SmallTab } from 'components';
import theme from 'theme';

import { UserSearchesV2Filter } from './type';
import { TabValues } from 'features/admin/containers/UserManagement';

const styles = {
  root: {
    borderBottom: `1px solid ${theme.palette.grey[300]}`,
    paddingRight: 2,
  },
  tabs: {
    '& .MuiTabs-indicator': {
      height: '2px',
    },
  },
};

interface Props {
  filter: UserSearchesV2Filter;
  setFilter: (filter: UserSearchesV2Filter) => void;
  tab: TabValues;
  setTab: (filter: TabValues) => void;
  actions?: ReactNode;
}

const TableHeader: FC<Props> = ({ filter, setFilter, tab, setTab, actions }) => {
  const { t } = useTranslation();

  function onChangeTabs(event: ChangeEvent<HTMLDivElement>, value: TabValues) {
    setTab(value);

    switch (value) {
      case TabValues.Onboarded:
        return setFilter({
          ...filter,
          user_status: UserStatus.Active,
          onboarding_completed: true,
          emails: [],
        });
      case TabValues.ExpressActivated:
        return setFilter({
          ...filter,
          onboarding_completed: false,
        });
      case TabValues.Suspended:
        if (filter?.onboarding_completed) {
          delete filter['onboarding_completed'];
        }
        return setFilter({
          ...filter,
          user_status: UserStatus.Disabled,
          emails: [],
        });
      case TabValues.Partially:
        return setFilter({
          ...filter,
          user_status: UserStatus.Active,
          onboarding_completed: false,
          emails: [],
        });
      case TabValues.Identified:
        return setFilter({
          ...filter,
          onboarding_completed: false,
          emails: [],
        });
    }
  }

  return (
    <Grid sx={styles.root} container alignItems="center" justifyContent="space-between">
      <Grid>
        <Tabs
          indicatorColor="primary"
          variant="scrollable"
          sx={styles.tabs}
          value={tab}
          onChange={onChangeTabs}
        >
          <SmallTab label={t('common:onboarded')} value={TabValues.Onboarded} />
          <SmallTab label={t('admin:partiallyOnboarded')} value={TabValues.Partially} />
          <SmallTab label={t('express:expressActivated')} value={TabValues.ExpressActivated} />
          <SmallTab label={t('common:identified')} value={TabValues.Identified} />
          <SmallTab label={t('admin:suspended')} value={TabValues.Suspended} />
        </Tabs>
      </Grid>
      <Grid>{actions}</Grid>
    </Grid>
  );
};

export default TableHeader;
